import React from "react";
import { motion } from "framer-motion";
import { FiArrowDown, FiPhone } from "react-icons/fi";
import PageBanner from "../../components/PageBanner";
import "../../styles/brand.css";

/* The headline and supporting line are the supplied Contact Us artwork's own,
   set as HTML instead of being baked into the picture. The page's H1
   ("Contact Us") stays in Contact.jsx directly below. */
const ContactBanner = () => (
  <PageBanner
    image="/assets/banners/contact-banner.webp"
    imageAlt="The MBA Solutions office building"
    focus="55% 50%"
    variant="wide"
    ariaLabel="Contact MBA Solutions"
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <p className="page-banner__eyebrow">Contact Us</p>
      <p className="page-banner__title">
        Let&rsquo;s Build a Stronger, <em>Compliant &amp; Sustainable Future</em>
      </p>
      <p className="page-banner__lead">
        Have questions about our services or need expert guidance? Our team is
        ready to help you achieve your compliance and certification goals.
      </p>
      <div className="page-banner__actions">
        <a href="#contact-form" className="page-banner__btn page-banner__btn--solid">
          Send Us A Message <FiArrowDown aria-hidden="true" />
        </a>
        <a href="tel:+923014900495" className="page-banner__btn page-banner__btn--ghost">
          <FiPhone aria-hidden="true" /> +92 301 4900495
        </a>
      </div>
    </motion.div>
  </PageBanner>
);

export default ContactBanner;
